import React, { useMemo } from 'react';
import styled from 'styled-components';

import { PunctualityData } from 'apis/merchant-gateway/insights';
import { Legends, VerticalBarChart } from 'modules/experience-core';

import { formatSeconds } from '../../utils';

const ChartRoot = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const PreparationTimeChart = ({
  legends,
  data,
  summaryKey,
}: {
  legends: Legends<'avgPreparationTimeSec'>;
  data: PunctualityData[];
  summaryKey: string;
}) => {
  const chartData = useMemo(() => {
    return data.map(item => {
      const { label, total } = item;
      return { avgPreparationTimeSec: total.avgPreparationTimeSec, name: label || '' };
    });
  }, [data]);

  return (
    <ChartRoot>
      <VerticalBarChart
        valueFormatter={formatSeconds}
        legends={legends}
        isStacked
        data={chartData}
        summaryKey={summaryKey}
      />
    </ChartRoot>
  );
};
